import styled from "@emotion/styled";
import { H1, SiteContainer } from "atoms";
import { Head } from "features/misc";
import { EditProfileDetails } from "./EditProfileDetails";
import { EditProfileEmail } from "./EditProfileEmail";

function EditProfile() {
  return (
    <SiteContainer width="sm">
      <Head title="Edit Your Profile" />
      <H1>Edit Profile</H1>

      <Section id="details">
        <EditProfileDetails />
      </Section>

      <Section id="email">
        <EditProfileEmail />
      </Section>
    </SiteContainer>
  );
}

const Section = styled.section(({ theme }) => ({
  marginBottom: "4rem",
  "& + &": {
    borderTop: `1px solid ${theme.colors.gray60}`,
    paddingTop: "4rem",
  },
}));

export { EditProfile };
